<template>
  <section class="hero is-light is-fullheight">
    <div class="hero-head">
      <!-- <Menu/> -->
    </div>
    <div class="hero-body">
      <div class="container">
        <h1 class="title is-1 name">Eduardo Torres Ruvalcaba</h1>
        <div class="columns">
          <div class="column">
            <p class="title is-2 has-text-left-desktop-only">Mechatronics engineer & software developer</p>
          </div>
          <div class="column is-two-thirds">
            <p class="subtitle is-3">I design, build and develop different kinds of projects, as a hobby or as a profesional</p>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import Menu from './Menu.vue'

  export default {
    name: 'Banner',
    components: {
      Menu
    }
  }
</script>

<style scoped>
  .name {
    padding-bottom: 3em;
  }
</style>
